import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardHeader from "components/Card/CardHeader"

const Filters = () => {
  return (
	<Card>
		<CardHeader>
			Filtros
		</CardHeader>
		<CardBody>

		</CardBody>
	</Card>
  )
}

export default Filters
